import React, { useEffect, useRef } from "react";

function LocationInput({ onLocationChange, resetLocationKey }) {
  const inputRef = useRef(null);

  useEffect(() => {
    const loadGooglePlaces = () => {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyB-AttzsuR48YIyyItx6x2JSN_aigxcC0E&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = initializeAutocomplete;
      document.body.appendChild(script);
    };

    const initializeAutocomplete = () => {
      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place && place.name) {
          console.log("City:", place.name);
        }

        if (place && place.address_components) {
          const stateComponent = place.address_components.find((component) =>
            component.types.includes("administrative_area_level_1")
          );
          if (stateComponent) {
            console.log("State:", stateComponent.long_name);
          }

          const countryComponent = place.address_components.find((component) =>
            component.types.includes("country")
          );
          if (countryComponent) {
            console.log("Country:", countryComponent.long_name);
          }
        }

        // Send the selected location to the parent component
        onLocationChange(place.formatted_address);
      });
    };

    loadGooglePlaces();

    return () => {
      // Clean up any scripts added
      const script = document.querySelector(
        `script[src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB-AttzsuR48YIyyItx6x2JSN_aigxcC0E&libraries=places"]`
      );
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [onLocationChange, resetLocationKey]);

  return (
    <div className="form-group">
      <label className="fw-bold">Location</label>
      <div className="input-group">
        <input
          type="text"
          name="location"
          ref={inputRef}
          className="form-control"
          key={resetLocationKey}
        />
      </div>
    </div>
  );
}

export default LocationInput;
